module.exports = __webpack_public_path__ + "img/USAID_Horizontal_RGB_294.ac845a17.png";